import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import DotLoader from './components/DotLoader';

import 'bootstrap-icons/font/bootstrap-icons.css';
import './i18n';
import { HelmetProvider } from 'react-helmet-async';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Suspense fallback={<DotLoader />}>
      <HelmetProvider>
        <App />
      </HelmetProvider>
    </Suspense>
  </React.StrictMode>
);
